import { CountdownBannerMicroProps } from "../types";
import useElementEvents from "@/hooks/eventing/useElementEvents";
import { useInView } from "react-intersection-observer";
import {
  DEFAULT_USE_IN_VIEW_OPTIONS,
  ElementType,
} from "@/constants/tagular/main";
import { useEffect } from "react";
import useTranslations from "@/i18n/useTranslations";

export default function CountdownBannerMicro({
  theme,
  header,
  countdownTime,
  htmlId,
  location,
  name,
  position,
  className,
}: CountdownBannerMicroProps) {
  const t = useTranslations("Common");
  const { elementClicked, elementViewed } = useElementEvents({
    webElement: {
      elementType: ElementType.Banner,
      htmlId: htmlId,
      location: location,
      name: name,
      position: position,
    },
  });

  const { ref: bannerRef, inView } = useInView(DEFAULT_USE_IN_VIEW_OPTIONS);

  useEffect(() => {
    if (inView) {
      elementViewed();
    }
  }, [inView, elementViewed]);

  if (!countdownTime) {
    return null;
  }

  return (
    <div
      ref={bannerRef}
      className={`flex flex-col md:flex-row gap-x-6 self-center items-center ${theme === "light" ? "bg-putty-400 text-primary-500" : "bg-primary-500 text-white"} w-full md:w-auto px-4 py-2 rounded-[8px] ${className}`}
    >
      <span className="font-bold elm-p4">{header}</span>
      <div className="flex flex-row items-center justify-center">
        <span className="font-bold elm-h4 mr-2">{countdownTime.days}</span>
        <span className="elm-p3">{t("days")}</span>
        <span className="mx-3 lg:mx-4 elm-h4 font-bold">:</span>
        <span className="font-bold elm-h4 mr-2">{countdownTime.hours}</span>
        <span className="elm-p3">{t("hours")}</span>
        <span className="mx-3 lg:mx-4 elm-h4 font-bold">:</span>
        <span className="font-bold elm-h4 mr-2">{countdownTime.minutes}</span>
        <span className="elm-p3">{t("minutes")}</span>
      </div>
    </div>
  );
}
